<template>
  <v-card class="my-3">
    <v-card-title primary-title>
      <h3 class="headline">Steps</h3>
    </v-card-title>
    <v-card-text>
      Add steps in the order you want them completed (eg. Intended learning outcomes, Mid placement, End placement, Reflection)
    </v-card-text>
    <v-list>
      <draggable 
        :list="steps" 
        :options="{handle:'.v-icon'}"
        @end="onEnd">
        <v-list-tile
          v-for="item in steps" 
          :key="item.step" 
          :to="{path: '/admin/courses/' + $route.params.course + '/' + $route.params.unit + '/' +item['.key']}"
          avatar 
        >
          <v-list-tile-action>
            <v-icon>drag_handle</v-icon>
          </v-list-tile-action>      
          <v-list-tile-content>          
            <v-list-tile-title class="title">{{ item.name }}</v-list-tile-title>          
          </v-list-tile-content>
          <v-list-tile-action class="hidden-xs-only">
            <v-list-tile-title>{{ item.type }}</v-list-tile-title>
          </v-list-tile-action>
        </v-list-tile>
      </draggable>
    </v-list>
    <v-card-text>
      <stepForm 
        :edititem="step"
        :item-order="(steps.length + 1)"/>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
import stepForm from "@/components/admin/stepForm";

export default {
  name: "Steps",
  components: {
    draggable,
    stepForm
  },
  data: () => ({
    steps: null,
    step: {}
  }),
  firestore() {
    return {
      steps: this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .doc(this.$route.params.unit)
        .collection("steps")
        .orderBy("itemOrder")
    };
  },
  methods: {
    onEnd(evt) {
      this.$store.dispatch("setLoading", true);
      var batch = this.$store.getters.db.batch();
      this.steps.forEach((element, index) => {
        let ref = this.$store.getters.db
          .collection("courses")
          .doc(this.$route.params.course)
          .collection("units")
          .doc(this.$route.params.unit)
          .collection("steps")
          .doc(element[".key"]);
        batch.update(ref, { itemOrder: +index + 1 });
      });

      batch.commit().then(() => {
        this.$store.dispatch("setLoading", false);
      });
    }
  }
};
</script>
